"use client";

import { useState } from "react";
import { Section } from "@/components/section";
import { ChevronDown } from "lucide-react";
import { content } from "@/data/content";

export function FaqSection() {
  const faq = content.faq;
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <Section id="faq" title={faq.title} subtitle={faq.subtitle}>
      <div className="max-w-3xl mx-auto space-y-3">
        {faq.items.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={item.question}
              className="border border-border rounded-lg overflow-hidden"
            >
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
                aria-controls={`faq-panel-${index}`}
                className="w-full flex items-center justify-between gap-4 p-5 text-left font-medium hover:bg-muted/50 transition-colors"
              >
                {item.question}
                <ChevronDown
                  className={`h-5 w-5 shrink-0 text-muted-foreground transition-transform duration-200 ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                id={`faq-panel-${index}`}
                hidden={!isOpen}
                className="px-5 pb-5"
              >
                <p className="text-muted-foreground">{item.answer}</p>
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
}
